'use client';

import Button from '@/components/Button';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { useTranslations } from '@/i18n/use-translations';
import { useRouter } from 'next/navigation';

const Banner = ({
  memberPrivileges,
  joinNowClick,
  SDRewardsPageBtnClick,
  className,
}: {
  memberPrivileges: any;
  joinNowClick?: () => void;
  SDRewardsPageBtnClick: (btnName: string) => void;
  className?: string;
}) => {
  const userInfo = useStore((state) => state.userInfo);
  const router = useRouter();
  const token = useStore((state) => state.token);
  const t = useTranslations('zeeloolRewards.banner');
  const setJoinFreeDialogInfo = useStore((state) => state.setJoinFreeDialogInfo);
  const bannerData = {
    title: t('title'),
    join_now_text: t('joinNow'),
    background_image: memberPrivileges.head_banner, // Placeholder for background image
    background_image_pc: memberPrivileges.head_banner_pc,
  };

  const handleJoinNow = () => {
    SDRewardsPageBtnClick('Join Now');
    if (!token) {
      joinNowClick?.();
      return;
    }

    if (userInfo.member_level > -1) {
      router.push('/account/zeelool-rewards');
    } else {
      setJoinFreeDialogInfo({
        show: true,
      });
    }
  };

  return (
    <>
      <WebOnly>
        <div
          className={`relative flex h-[400px]  items-center justify-start bg-cover bg-center text-center text-white pl-[40px] ${className}`}
          style={{
            backgroundImage: `url(${bannerData?.background_image_pc})`,
          }}
        >
          <div className="flex flex-col items-start justify-center">
            <h1 className="text-[40px] font-bb text-white ">{bannerData.title}</h1>
            <div className="mt-[30px]">
              <Button
                className="w-[240px] !font-bb"
                variant="contained"
                color="primary"
                radiusSize="large"
                onClick={() => handleJoinNow()}
              >
                {bannerData.join_now_text}
              </Button>
            </div>
          </div>
        </div>
      </WebOnly>
      <WapOnly>
        <div
          className="relative h-[240px] bg-cover bg-center text-center text-white"
          style={{
            backgroundImage: `url(${bannerData.background_image})`,
          }}
        >
          <h1 className="text-[20px] leading-[24px] font-bb text-white pt-[144px]">
            {bannerData.title}
          </h1>
          <div className="mt-[16px] w-[100%]">
            <Button
              className="w-[264px] h-[36px] text-[14px] font-bb"
              variant="contained"
              color="primary"
              radiusSize="large"
              onClick={() => handleJoinNow()}
            >
              <span className="text-[14px] font-bb">{bannerData.join_now_text}</span>
            </Button>
          </div>
        </div>
      </WapOnly>
    </>
  );
};

export default Banner;
